<button type="button" [ngClass]="btnClass" *ngIf="!(accountService.account | async)" (click)="connect()">Connect Wallet</button>
<div *ngIf="accountService.account | async">
  <button type="button" [ngClass]="btnClass" *ngIf="!(chainMatched | async)" (click)="switchNetwork()">{{ switchText }}</button>
  <div *ngIf="chainMatched | async">
    <ng-content></ng-content>
  </div>
</div>
